import { Box, Button, Modal } from "@mui/material";
import Logo from "../../components/image/bfiloader.gif"
const DownloadPdfLoaderModal = ({ loading, name, abort }) => {
  return (
    <Modal open={loading}>
      <Box
        style={{
          width: "100%",
          height: "100vh",
          border: "2px solid cadetblue",
          padding: "30px",
          textAlign: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <div style={{ background: "#fff", padding: "2rem 4rem", borderRadius: "20px", display: "grid" }}>
          <img
            src={Logo}
            alt="logo"
            style={{ height: "150px", borderRadius: "5%" }}
          />

          {abort && (
            <Button
              variant="contained"
              style={{ backgroundColor: "grey" }}
              size="small"
              onClick={() => {
                if (window.confirm("Are you sure you want to Abort Downloading?")) {
                  window.history.back();
                }
              }}
            >
              Abort Downloading
            </Button>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default DownloadPdfLoaderModal;
